
















import { Vue, Component, Prop } from "vue-property-decorator";
import { QuestionareModule } from "@/store/questionary.module";

@Component
export default class InfoQuestionary extends Vue {
  get text() {
    return this.$t("questionnaire.notice").toString();
  }

  expanded: boolean = false;

  get truncatedText() {
    return this.text.substr(0, 58) + "...";
  }

  toggleMessage() {
    this.expanded = !this.expanded;
  }

  showQuestionare() {
    QuestionareModule.setshowQuestionnaire(true);
  }
}
